import React from 'react';

import { Button, Modal } from 'player-components';
// import { SignalSlashIcon } from '@heroicons/react/24/outline';
import { RectangleStackIcon, SignalSlashIcon } from '@heroicons/react/20/solid';

import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

const OffLineContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    svg {
        height: 40px;
    }
    p {
        margin-top: 30px;
    }
    button {
        margin-top: 30px;
        svg {
            height: 20px;
            margin-right: 10px;
        }
    }
`;

const OfflineModal = ({isOpen, onClose}) => {  
    
    
    return <Modal 
        title="You are offline!"
        isOpen={isOpen}
        content={<OffLineContainer>
            <SignalSlashIcon />
            <p>While using this app without an internet connection, you can only play setlists that you have been set to be available offline.</p>
        </OffLineContainer>}
        onClose={onClose}
        onConfirm={onClose}
        confirmLabel={<> Go to setlists</>}
        confirmable={true}
    />
}

export default OfflineModal;